// Custom select field component
function SelectField(props: {
    id: string;
    label: string;
    extra?: string;
    placeholder?: string;
    variant?: string;
    state?: string;
    disabled?: boolean;
    onChange?: any;
    defaultValue?: string;
    value?: string;
    options: string[];
    required?: boolean;
}) {
    const {
        label,
        id,
        extra,
        placeholder,
        variant,
        state,
        disabled,
        onChange,
        defaultValue,
        value,
        options,
        required,
    } = props;

    return (
        <div className={`${extra}`}>
            <label
                htmlFor={id}
                className={`text-sm font-semibold text-gray-700 dark:text-white ${
                    variant === 'auth' ? 'ml-1' : 'ml-1'
                }`}
            >
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <select
                onChange={onChange}
                disabled={disabled}
                defaultValue={defaultValue}
                value={value}
                id={id}
                className={`mt-2.5 flex h-14 w-full items-center justify-center rounded-xl border-2 bg-white px-4 text-base outline-none transition-all duration-200 cursor-pointer ${
                    disabled === true
                        ? '!border-gray-200 !bg-gray-50 text-gray-400 cursor-not-allowed'
                        : state === 'error'
                        ? 'border-red-400 bg-red-50/50 text-gray-900 focus:border-red-500 focus:bg-white focus:ring-4 focus:ring-red-100'
                        : state === 'success'
                        ? 'border-green-400 bg-green-50/50 text-gray-900 focus:border-green-500 focus:bg-white focus:ring-4 focus:ring-green-100'
                        : 'border-gray-200 text-gray-900 focus:border-brand-500 focus:bg-white focus:ring-4 focus:ring-brand-100 hover:border-gray-300'
                }`}
            >
                {placeholder && (
                    <option value="" disabled className="text-gray-400">
                        {placeholder}
                    </option>
                )}
                {options.map((option, index) => (
                    <option key={index} value={option} className="text-gray-900">
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default SelectField;
